// Cola de un solo elemento para el aviso de denegación de permiso.
//
// Hace falta la cola y no basta con llamar a window.VMA.showError() desde el
// guard: `window.VMA` se asigna en App.vue:mounted y todavía no existe cuando
// corre el primer guard del arranque. El guard encola y App.vue drena.
let pending = null

export function setPendingNotice(notice) {
  pending = notice || null
}

export function takePendingNotice() {
  const notice = pending
  pending = null
  return notice
}
